<template>
    <div>
        <div class="d-flex align-items-center justify-content-between mt-4 text-primary">
            <h1 class="page-title h1">Moje sklepy</h1>
            <div
                v-if="editLocationId"
                class="d-none d-lg-flex gap-1"
            >
                <the-btn
                    text="Anuluj"
                    class="btn-outline-custom"
                    @click.native="abortEditMode"
                />
                <the-btn
                    text="Zapisz"
                    class="btn-secondary"
                    icon="Save"
                    icon-class="mr-2"
                    :disabled="isSaveShopBtnDisabled"
                    @click.native="saveShop"
                >
                    <button-spinner
                        class="ml-3"
                        :status="$store.getters.getStoreDataStatus"
                    />
                </the-btn>
            </div>
        </div>
        <page-preloader
            v-if="userStoresStatus === 'loading'"
            :is-loading="true"
        />
        <div v-else-if="userStoresTableData?.body">
            <ui-data-table
                class="mb-5 overflow-visible"
                tr-spacing
                headers-on-mobile
                mobile-breakpoint="lg"
                :table-data="userStoresTableData"
            />
        </div>
        <div v-else>
            Brak sklepów.
        </div>
        <template v-if="editLocationId">
            <div
                class="m-stickyBar d-flex d-lg-none flex-wrap justify-content-end gap-1"
                style="position: sticky; bottom: 0; background: #fff"
            >
                <the-btn
                    text="Anuluj"
                    class="btn-outline-custom"
                    @click.native="abortEditMode"
                />
                <the-btn
                    text="Zapisz"
                    class="btn-secondary"
                    icon="Save"
                    icon-class="mr-2"
                    @click.native="saveShop"
                    :disabled="isSaveShopBtnDisabled"
                >
                    <button-spinner
                        class="ml-3"
                        :status="$store.getters.getStoreDataStatus"
                    />
                </the-btn>
            </div>
        </template>
    </div>
</template>

<script>
import PagePreloader from '@/components/global/ui/PagePreloader.vue'
import StoreDevices from '@/components/settings/userStores/StoreDevices.vue'
import UserStoresTableActions from '@/components/settings/userStores/UserStoresTableActions.vue'
import OpeningHours from '@/components/settings/userStores/OpeningHours.vue'
import StoreStatus from '@/components/settings/userStores/StoreStatus.vue'
import StoreSocialMedia from '@/components/settings/userStores/StoreSocialMedia'
import StoreContactTableData from '@/components/settings/userStores/StoreContactTableData'
import StoreEdit from '@/components/settings/userStores/StoreEdit.vue'
import StoreTableMainData from '@/components/settings/userStores/StoreTableMainData'
import StoreLocationIdData from '../../components/settings/userStores/StoreLocationIdData'
// TODO: TEMP edit store data (address) hidden
// import TheFormVue from '../../components/global/ui/TheForm.vue'

export default {
    name: 'UserStores',
    data() {
        return {
            userStoresTableData: null,
            editLocationId: null,
            tempUserLocations: null,
            storeNameForm: [
                {
                    name: 'store-name',
                    title: 'Nazwa sklepu',
                    path: 'full_name'
                }
            ],
            storeAddresForm: [
                {
                    name: 'store-street',
                    title: 'Ulica',
                    path: 'address.street'
                },
                {
                    name: 'store-building',
                    title: 'Numer budynku',
                    path: 'address.building',
                    class: 'col-6'
                },
                {
                    name: 'store-local',
                    title: 'Numer lokalu',
                    path: 'address.local',
                    class: 'col-6'
                },
                {
                    name: 'store-postal-code',
                    title: 'Kod pocztowy',
                    path: 'address.postalCode',
                    class: 'col-6'
                },
                {
                    name: 'store-city',
                    title: 'Miejscowość',
                    path: 'address.city',
                    class: 'col-6'
                }
            ],
            socialMediaLinks: [
                {
                    name: 'facebook',
                    icon: 'Facebook',
                    path: 'link_to_facebook',
                    inputPlaceholder: 'Dodaj link do Facebooka'
                },
                {
                    name: 'instagram',
                    icon: 'Instagram',
                    path: 'link_to_instagram',
                    inputPlaceholder: 'Dodaj link do Instagrama'
                },
                {
                    name: 'youtube',
                    icon: 'Youtube',
                    path: 'link_to_youtube',
                    inputPlaceholder: 'Dodaj link do Youtube'
                },
                {
                    name: 'website',
                    icon: 'Website',
                    path: 'link_to_website',
                    inputPlaceholder: 'Dodaj link do strony internetowej'
                }
            ],
            invalidEditModeValues: {
                name: false,
                area: false,
                phone: false,
                email: false
            }
        }
    },
    components: {
        PagePreloader
    },
    computed: {
        userStoresStatus() {
            return this.$store.getters.getDiagnosticsStatus
        },
        diagnostics() {
            return this.$store.getters.getLocationsDiagnostics
        },
        userLocations: {
            get() {
                if (this.editLocationId) {
                    return this.$store.getters.getUserLocations.filter(
                        el => el.location_id === this.editLocationId
                    )
                } else {
                    return this.$store.getters.getUserLocations
                }
            },
            set(val) {
                this.$store.dispatch('setMergedUserLocations', val)
            }
        },
        isShopUser() {
            return this.$store.getters.isShopUser
        },
        isSaveShopBtnDisabled() {
            return (
                (JSON.stringify(this.tempUserLocations) ===
                    JSON.stringify(this.$store.getters.getUserLocations) &&
                    !this.$store.getters.getStoreDataChangedValue) ||
                    Object.values(this.invalidEditModeValues).some(v => v) ||
                    this.$store.getters.getStoreDataStatus === 'loading'
            )
        }
    },
    watch: {
        userLocations() {
            this.setUserDataTable(this.userLocations)
        },
        invalidEditModeValues() {
            this.setUserDataTable(this.userLocations)
        }
    },
    created() {
        this.$store.dispatch('diagnosticsFetch', { mode: 'locations' })
        this.$store
            .dispatch('extendedDataFetch', {
                includes: 'locations'
            })
            .then(() => {
                this.setUserDataTable(this.userLocations)
            })
        this.$store.dispatch('locationsSynchronizationFetch')
    },
    methods: {
        setUserDataTable(userLocations) {
            const tableClass = this.editLocationId
                ? 'table-shops --edit'
                : 'user-stores'
            const head = this.editLocationId
                ? [
                    'Dane sklepu',
                    'Godziny otwarcia',
                    'Linki do mediów społecznościowych'
                ]
                : [
                    'Status',
                    'Nazwa sklepu',
                    'Dane sklepu',
                    'Identyfikator',
                    'Godziny otwarcia',
                    'Przynależność<br/> sklepu do sieci',
                    'Dane kontaktowe',
                    'Urządzenia'
                ]

            const body =
                userLocations &&
                userLocations &&
                userLocations.map((location, itemIdx) => {
                    let locations = []
                    if (this.editLocationId) {
                        locations = [
                            {
                                type: 'component',
                                component: StoreEdit,
                                config: {
                                    location,
                                    invalidEditModeValues: this.invalidEditModeValues,
                                    setInvalidEditModeValues: val => {
                                        this.invalidEditModeValues = val
                                    }
                                }
                            },
                            // TODO: TEMP edit store data (address) hidden
                            // {
                            //     type: 'component',
                            //     component: TheFormVue,
                            //     config: {
                            //         formFields: this.storeAddresForm,
                            //         data: location,
                            //         errors: this.userStoresErrors
                            //     }
                            // },
                            {
                                type: 'component',
                                component: OpeningHours,
                                config: {
                                    editMode: !!this.editLocationId,
                                    hours: location,
                                    editLocationId: this.editLocationId,
                                    tempData: this.tempUserLocations.filter(
                                        el =>
                                            el.location_id ===
                                            this.editLocationId
                                    )[0]
                                }
                            },
                            {
                                type: 'component',
                                component: StoreSocialMedia,
                                config: {
                                    data: location,
                                    tempData: this.tempUserLocations.filter(
                                        el =>
                                            el.location_id ===
                                            this.editLocationId
                                    )[0],
                                    linkFields: this.socialMediaLinks,
                                    editMode: !!this.editLocationId
                                }
                            }
                        ]
                    } else {
                        locations = [
                            {
                                type: 'component',
                                component: StoreStatus,
                                config: {
                                    status: location.status === 'Y',
                                    closingDate: location.closing_date
                                }
                            },
                            {
                                text: location.full_name,
                                style: {
                                    'font-weight': '600',
                                    'overflow-wrap': 'normal'
                                },
                                customClass: 'text-primary'
                            },
                            {
                                type: 'component',
                                component: StoreTableMainData,
                                config: {
                                    data: location
                                }
                            },
                            {
                                type: 'component',
                                component: StoreLocationIdData,
                                config: {
                                    location_id: location.location_id,
                                    pin: location.pin
                                }
                            },
                            {
                                type: 'component',
                                component: OpeningHours,
                                config: {
                                    hours: location,
                                    networkName: this.setNetworkName(
                                        location.network_name
                                    ),
                                    editLocationId: location.id,
                                    tempData: location
                                }
                            },
                            {
                                text: this.setNetworkName(location.network_name),
                                customClass: 'text-nowrap'
                            },
                            {
                                type: 'component',
                                component: StoreContactTableData,
                                config: {
                                    data: location,
                                    linkFields: this.socialMediaLinks
                                }
                            },
                            {
                                type: 'component',
                                component: UserStoresTableActions,
                                mode: 'action',
                                config: {
                                    up: false,
                                    devices: location.devices,
                                    isShopUser: this.isShopUser,
                                    onClick: () => {
                                        const expandedRow = this.userStoresTableData.body[
                                            itemIdx
                                        ].find(
                                            e => e.type && e.type === 'expanded'
                                        )
                                        expandedRow.show = !expandedRow.show
                                        this.userStoresTableData.body[
                                            itemIdx
                                        ].find(
                                            e =>
                                                e.type === 'component' &&
                                                e.mode === 'action'
                                        ).config.up = expandedRow.show
                                    },
                                    onClickEdit: () => {
                                        this.tempUserLocations = JSON.parse(
                                            JSON.stringify(this.userLocations)
                                        )
                                        this.editLocationId =
                                            location.location_id
                                        window.scrollTo(0, 1)
                                    }
                                }
                            }
                        ]
                        if (location.devices && location.devices.length) {
                            locations.push({
                                type: 'expanded',
                                component: StoreDevices,
                                show: false,
                                componentConfig: {
                                    location
                                }
                            })
                        }
                    }
                    return locations.filter(e => !e.isHidden)
                })
            this.userStoresTableData = { head, body, tableClass }
        },
        saveShop() {
            if (!this.editLocationId || Object.values(this.invalidEditModeValues).some(v => v)) {
                return
            }
            this.$store
                .dispatch('saveUserLocation', {
                    editLocationId: this.editLocationId,
                    tempUserLocations: this.tempUserLocations
                })
                .then(() => {
                    this.$store.dispatch('extendedDataFetch', {
                        includes: 'locations'
                    })
                    this.editLocationId = null
                })
        },
        abortEditMode() {
            this.editLocationId = null
            this.invalidEditModeValues = {
                name: false,
                area: false,
                phone: false,
                email: false
            }

            this.$store.dispatch('diagnosticsFetch', { mode: 'locations' })
            this.$store
                .dispatch('extendedDataFetch', {
                    includes: 'locations'
                })
                .then(() => {
                    this.setUserDataTable(this.userLocations)
                })
        },
        setNetworkName(name) {
            name = name ? name.replace('_Network', '') : '-'

            if (name === 'INDEPENDENT') {
                name = 'Niezrzeszony'
            }

            return name
        }
    }
}
</script>
